import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Dashboard } from "@/pages/Dashboard";

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <div className="App">
      <Dashboard theme={theme} toggleTheme={toggleTheme} />
      <Toaster position="top-right" richColors closeButton theme={theme} />
    </div>
  );
}

export default App;
